export default "__VITE_PUBLIC_ASSET__09991ce7__"